import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["panelKey", "width", "onCloseComplete", "onCloseStart", "onEsc", "onOpenComplete", "onOpenStart", "rootNode", "size", "children"];
import { useEffect, useRef } from 'react';
import { callIfPossible } from '../../utils/functions';
import { PanelContext } from '../../context/PanelContext';
import AbstractModal from '../AbstractModal/AbstractModal';
import { ModalPanelTransition } from './ModalPanelTransition';
import { isSafari } from '../../utils/BrowserTest';
import { ModalPanelProvider, useModalPanelContext } from './ModalPanelProvider';
import { deepMerge } from '../../utils/deepMerge/deepMerge';
import { jsx as _jsx } from "react/jsx-runtime";
const inPanelContext = {
  inPanel: true
};
export const ModalPanel = _ref => {
  var _modalPanelContext$ov, _modalPanelContext$fo;
  let {
      width = 700,
      onCloseComplete,
      onCloseStart,
      onEsc,
      onOpenComplete,
      onOpenStart,
      rootNode,
      size,
      children
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const autoFocusedEl = useRef(null);
  const modalPanelContext = useModalPanelContext();
  useEffect(() => {
    if (isSafari()) {
      autoFocusedEl.current = document.activeElement;
      autoFocusedEl.current.blur();
    }
    return () => {
      if (isSafari() && autoFocusedEl.current) {
        autoFocusedEl.current.focus();
      }
    };
  }, []);
  const overlayStylesOverrides = deepMerge({
    overflow: 'hidden'
  }, (_modalPanelContext$ov = modalPanelContext === null || modalPanelContext === void 0 ? void 0 : modalPanelContext.overlayStylesOverrides) !== null && _modalPanelContext$ov !== void 0 ? _modalPanelContext$ov : {});
  const formStyleOverrides = deepMerge({
    display: 'flex',
    flex: '1 1 100%',
    flexDirection: 'column',
    maxHeight: '100%',
    flexGrow: 1
  }, (_modalPanelContext$fo = modalPanelContext === null || modalPanelContext === void 0 ? void 0 : modalPanelContext.formStylesOverrides) !== null && _modalPanelContext$fo !== void 0 ? _modalPanelContext$fo : {});
  const handleOpenComplete = () => {
    callIfPossible(onOpenComplete);
    if (isSafari() && autoFocusedEl.current) {
      autoFocusedEl.current.focus();
    }
  };
  return /*#__PURE__*/_jsx(ModalPanelProvider, {
    overlayStylesOverrides: overlayStylesOverrides,
    formStylesOverrides: formStyleOverrides,
    children: /*#__PURE__*/_jsx(PanelContext.Provider, {
      value: inPanelContext,
      children: /*#__PURE__*/_jsx(AbstractModal, Object.assign({}, rest, {
        use: "sidebar",
        _dialogWidth: width,
        size: size,
        componentName: "ModalPanel",
        Transition: ModalPanelTransition,
        onOpenStart: onOpenStart,
        onOpenComplete: handleOpenComplete,
        onCloseStart: onCloseStart,
        onCloseComplete: onCloseComplete,
        rootNode: rootNode,
        onEsc: onEsc,
        children: children
      }))
    })
  });
};